import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-items-modal',
  templateUrl: './items-modal.component.html',
  styleUrls: ['./items-modal.component.scss'],
})
export class ItemsModalComponent implements OnInit {
  isLoading = true;
  Errors = null;
  items = null;
  mode = null;
  data = null;
  Success = null;
  depts = null;
  subs = null;
  socs: any = [];
  filterddata: any = [];
  socsData: any = [];
  private _searchText: string;
  results: any = [];
  itemsAll = [];
  role = localStorage.getItem('role');
  socId = '';

  get searchText(): string {
    return this._searchText;
  }

  set searchText(value: string) {
    this._searchText = value;
    this.filterddata = this.filterdata(value);
  }

  onSearch(): void {
    this.filterddata = this.filterdata(this.searchText);
  }

  filterdata(searchString: string) {
    return this.socsData.filter(
      (log) => log.name.toLowerCase().indexOf(searchString.toLowerCase()) !== -1
    );
  }

  groupForm = new FormGroup({
    name: new FormControl('', Validators.required),
    machine_code: new FormControl('', Validators.required),
    dept_id: new FormControl('', Validators.required),
    sub_dept_id: new FormControl('', Validators.required),
    soc_id: new FormControl(null, Validators.required),
    price_editable: new FormControl('', Validators.required),
    direct_revenue: new FormControl('', Validators.required),
    status: new FormControl('', Validators.required),
    one_time: new FormControl('', Validators.required),
    doctor_reqd: new FormControl('', Validators.required),
    NABL_Accredited: new FormControl('', Validators.required),
    report_type: new FormControl('', Validators.required),
    Daily: new FormControl('', Validators.required),
    profile: new FormControl(null, Validators.required),
    release_dr_fee_when_unsettled: new FormControl('', Validators.required),
    methodology: new FormControl('', Validators.required),
    id: new FormControl(null, Validators.required),
    service_price: new FormControl(null, Validators.required),
    result_format_id: new FormControl(null),
  });

  groupFormPrice = new FormGroup({
    soc_id: new FormControl(null, Validators.required),
    item_id: new FormControl(null, Validators.required),
    amount: new FormControl(null, Validators.required),
  });

  constructor(
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public auth: SettingsService
  ) {}

  onSubmit1(e) {
    let data = {
      soc_id: +this.groupFormPrice.value.soc_id,
      item_id: this.groupFormPrice.value.item_id,
      amount: +this.groupFormPrice.value.amount,
      // name: this.groupFormPrice,
    };
    this.itemsAll.push(data);
    console.log(this.itemsAll);
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;

    this.auth.addPriceSoc(this.itemsAll).subscribe(
      (resSuccess) => {
        this.data = resSuccess;
        this.isLoading = false;
        console.log(resSuccess);

        if (this.data.success) {
          this.closeModal();
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this._snackBar.open('Error: please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log('error');
        }
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
        this._snackBar.open(resErr, '', {
          duration: 2000,
          verticalPosition: 'top',
        });
      }
    );
  }

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      id,
      name,
      machine_code,
      dept_id,
      sub_dept_id,
      soc_id,
      direct_revenue,
      status,
      price_editable,
      one_time,
      doctor_reqd,
      NABL_Accredited,
      report_type,
      Daily,
      profile,
      release_dr_fee_when_unsettled,
      methodology,
      service_price,
      result_format_id,
    } = this.groupForm.value;
    console.log(this.groupForm.value);
    this.auth
      .postItem(
        id,
        name,
        machine_code,
        dept_id,
        sub_dept_id,
        soc_id,
        direct_revenue,
        status,
        price_editable,
        one_time,
        doctor_reqd,
        NABL_Accredited,
        report_type,
        Daily,
        profile,
        release_dr_fee_when_unsettled,
        methodology,
        service_price,
        result_format_id
      )
      .subscribe(
        (resSuccess) => {
          this.data = resSuccess;
          this.isLoading = false;
          console.log(resSuccess);

          if (this.data.success) {
            this.closeModal();
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            this.Errors = 'Not successful, please try again';
            console.log(resSuccess);
          }
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr);
        }
      );
  }

  closeModal() {
    this.modal.closeModal();
  }

  ngOnInit(): void {
    this.auth.gettemplatesMode('RESULT').subscribe(
      (resSuccess) => {
        this.results = resSuccess;
        console.log(this.results);
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );

    this.auth.getDept().subscribe(
      (resSuccess) => {
        this.depts = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getSocs().subscribe(
      (resSuccess) => {
        this.socs = resSuccess;
        console.log(this.socs);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getSubDept().subscribe(
      (resSuccess) => {
        this.subs = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
    this.auth.getItems().subscribe(
      (resSuccess) => {
        this.items = resSuccess;
        this.filterddata = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }

  // socSelect(e){

  // }

  socSelect(soc) {
    this.isLoading = true;
    this.auth.getItemBySocId(this.socId).subscribe(
      (resSuccess: any) => {
        this.isLoading = false;
        this.filterddata = resSuccess;
        this.socsData = resSuccess;
        console.log(this.filterddata, 'Socccccccc');
      },
      (resErr) => {
        this.Errors = resErr;
        this.isLoading = false;
      }
    );
  }

  addNew() {
    this.mode = 'add';
  }
  edit(item) {
    this.mode = 'edit';
    this.groupForm.patchValue({
      name: item.name,
      id: item.id,
      machine_code: item?.machine_code,
      dept_id: item.dept_id,
      sub_dept_id: item.sub_dept_id,
      soc_id: item.soc_id,
      direct_revenue: item.direct_revenue,
      status: item.status,
      price_editable: item.price_editable,
      one_time: item.one_time,
      doctor_reqd: item.doctor_reqd,
      NABL_Accredited: item.NABL_Accredited,
      report_type: item.report_type,
      Daily: item.Daily,
      profile: item.profile,
      release_dr_fee_when_unsettled: item.release_dr_fee_when_unsettled,
      methodology: item.methodology,
      service_price: item.service_price,
      result_format_id: item.result_format_id,
    });
    this.groupFormPrice.patchValue({
      soc_id: item.soc_id,
      item_id: item.id,
      amount: item.service_price,
    });
    console.log(this.groupForm.value);
    console.log(this.groupFormPrice.value);
    // if (this.groupForm.value.soc_id === '') {
    //   this.groupForm.patchValue({
    //     soc_id: 1,
    //   });
    // }
    // if (this.groupFormPrice.value.soc_id === '') {
    //   this.groupForm.patchValue({
    //     soc_id: 1,
    //   });
    // }
  }

  price() {
    this.mode = 'price';
  }
  back() {
    this.mode = 'edit';
  }

  delete(title) {
    this.auth.delSet('/api/items/deleteItem', title.id).subscribe(
      (resSuccess) => {
        this.filterddata = this.filterddata.filter(
          (dattum) => dattum.id !== title.id
        );
        this._snackBar.open('Deleted Successfully', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
      },
      (resErr) => {
        this._snackBar.open('Error try again', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
      }
    );
  }
}
